module.exports = __webpack_public_path__ + "img/tamamlayici-saglik-sigortasi.90f1401e.png";